import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SearchServiceUs } from '../../../services/us-search/us-search.service';
import { UserService } from 'src/app/feature/user/services/user.service';
import { CommonService } from 'src/app/shared/services/common/common.service';
import { HomeService } from 'src/app/feature/user/services/home/home.service';
import { config } from 'src/assets/config/config';
import { SharedService } from 'src/app/shared/services/shared/shared.service';


@Component({
  selector: 'app-search-results-us',
  templateUrl: './search-us-results.component.html',
  styleUrls: ['./search-us-results.component.scss']
})
export class SearchResultsComponentUs implements OnInit {

  public searchedKeyword: any;
  public allSearchedData: any;
  public serverError = false;
  private unsubscribe$ = new Subject();
  public allSearchResults: any;
  public correctedKeyword: any;
  public showMoreData: any;
  public showMore = false;
  public splittedKeywords = [];
  private _currentPopover: any;
  @ViewChildren(PopoverDirective) popovers: QueryList<PopoverDirective>;
  public allResults: any;
  public correctedWord: string;
  buttonTexts: string[] = [
    'How do I apply for a D-U-N-S Number?',
    'What are the benefits of having a D-U-N-S Number ?',
    'Can I apply for it internationally ?',
    'Duplicate DUNS Investigation'
  ];
  allSfdcData: any;
  private storedQueryParams: Params = {};
  private currentLang: any
  languageSubscription: Subscription;

  constructor(
    private route: ActivatedRoute,
    private commonService: CommonService,
    private searchService: SearchServiceUs,
    private router: Router,
    private sharedService: SharedService,
    private homeService: HomeService,
    private uService: UserService,
    private ngxService: NgxUiLoaderService) {
    this.route?.queryParams?.subscribe(
      (params: Params) => {
        if (this.router.url.indexOf('/search/search-results') > -1) {
          this.searchedKeyword = params['keyword'];
          this.splittedKeywords = this.searchedKeyword.split(" "); 
          this.getAllSearchTask(this.searchedKeyword);
          if (Object.keys(params).length > 0) {
            this.storedQueryParams = { ...params };  // Store the query params
          }
        }
      }
    )
  }

  ngOnInit(): void {
    this.ngxService.start();
    // this.languageSubscription = this.commonService.language$.subscribe(lang => {
    //   this.currentLang = lang;
    //   this.preserveQueryParamsOnLangChange();
    // })
    this.searchedKeyword = this.route?.snapshot?.queryParamMap?.get('keyword');
    this.homeService.getSfdcData()
    // .pipe(takeUntil(this.unsubscribe$))
    .subscribe((resp) => {
      if (resp) {
        console.log("us search ");
        this.ngxService.stop();
        this.allSfdcData = resp.records;
        this.getAllSearchTask(this.searchedKeyword);
      }
    });
    //  // for GA
     this.uService.emitEvent(this.searchedKeyword, "Searched Keyword", "SearchSuccess", 8);
    //  // for GA
    
    this.commonService.initQualtrics();
  }

    /**
 * Method to preserve query parameters when the language is switched
 */
  //   preserveQueryParamsOnLangChange(): void {
  //     const langParam = this.sharedService.getDefaultCountry();
  //     const path = `/search/search-results`;
  //     this.router.navigate([path], { queryParams: this.storedQueryParams });
  // }

  public closeOldPopover(popover: any): void {
    if (this._currentPopover && this._currentPopover !== popover) {
      this._currentPopover.hide();
    }
  
    this._currentPopover = popover;
  }

  /**
   * @description Method to get all search data from API
   */


  // public getAllSearchTask(keyword: string): void {
  //   this.ngxService.start();

  //   if (!this.allSfdcData || this.allSfdcData.length === 0) {
  //     this.ngxService.stop();
  //     this.serverError = true;
  //     return;
  //   }

  //   const mainWords = keyword
  //     .toLowerCase()
  //     .replace(/[^a-zA-Z0-9 ]/g, "")
  //     .split(" ")
  //     .filter(word => !["or", "and", "the", "in", "is", "a"].includes(word));
  //   console.log("Main Words Extracted:", mainWords);

  //   const filteredResults = this.allSfdcData.filter((item: any) => {
  //     const normalizedTitle = this.normalizeText(item.Title);
  //     const normalizedContent = item.Content ? this.normalizeText(item.Content) : "";

  //     return mainWords.some(word => normalizedTitle.includes(word) || normalizedContent.includes(word));
  //   });

  //   this.ngxService.stop();

  //   if (filteredResults.length > 0) {
  //     this.allSearchedData = filteredResults;
  //     this.getCorrectedKeyword();
  //     this.allResults = filteredResults.map((item: any) => {
  //       item['highlight.Title'] = item['highlight.Title']
  //         ?.replaceAll("&lt;", "<")
  //         .replaceAll("&gt;", ">")
  //         .replaceAll("&#x2F;", "/")
  //         .replaceAll("&amp;reg;", "®");
  //       return item;
  //     });

  //     this.allSearchResults = this.allResults.slice(0, 30);
  //     this.showMore = filteredResults.length > 30;
  //     this.showMoreData = filteredResults.slice(0, 50);
  //     console.log(this.showMoreData.length, this.allSearchResults.length);

  //   } else {
  //     this.allSearchedData = null;
  //     this.allSearchResults = [];
  //   }

  //   this.searchService.emitData({ data: true });
  // }
  //above is merged reposne
  public getAllSearchTask(keyword: string): void {
    this.ngxService.start();

    if (!this.allSfdcData || this.allSfdcData.length === 0) {
        this.ngxService.stop();
        this.serverError = true;
        return;
    }
    const mainWords = keyword
        .toLowerCase()
        .replace(/[^a-zA-Z0-9 ]/g, "")
        .split(" ")
        .filter(word => !["or", "and", "the", "in", "is", "a"].includes(word)); 

    let titleMatches = this.allSfdcData.filter((item: any) => {
        const normalizedTitle = this.normalizeText(item.Title);
        return mainWords.some(word => normalizedTitle.includes(word));
    });
    let contentMatches = this.allSfdcData.filter((item: any) => {
        const normalizedContent = item.Content ? this.normalizeText(item.Content) : "";
        return mainWords.some(word => normalizedContent.includes(word)) &&
               !titleMatches.some((titleItem: any) => titleItem.Id === item.Id);
    });
    const filteredResults = [...titleMatches, ...contentMatches];

    this.ngxService.stop();

    if (filteredResults.length > 0) {
        this.allSearchedData = filteredResults;
        this.getCorrectedKeyword();
        this.allResults = filteredResults.map((item: any) => {
            item['highlight.Title'] = item['highlight.Title']
                ?.replaceAll("&lt;", "<")
                .replaceAll("&gt;", ">")
                .replaceAll("&#x2F;", "/")
                .replaceAll("&amp;reg;", "®");
            return item;
        });

        this.allSearchResults = this.allResults.slice(0, 30);
        this.showMore = filteredResults.length > 30;
        this.showMoreData = filteredResults.slice(0, 50);
    } else {
        this.allSearchedData = null;
        this.allSearchResults = [];
    }

    this.searchService.emitData({ data: true });
}

  private normalizeText(text: string): string {
    return text.toLowerCase().replace(/[^a-z0-9]/g, "");
  }


  // public getAllSearchTask(keyword: string): void {
  //   this.ngxService.start();
  
  //   if (!this.allSfdcData || this.allSfdcData.length === 0) {
  //     this.ngxService.stop();
  //     this.serverError = true;
  //     return;
  //   }
  
  //   // Extract main keywords (remove common words)
  //   const mainWords = keyword
  //     .toLowerCase()
  //     .replace(/[^a-zA-Z0-9 ]/g, "") // Remove special characters
  //     .split(" ") // Split into words
  //     .filter(word => !["or", "and", "the", "in", "is", "a"].includes(word)); // Remove stopwords
  
  //   console.log("Main Words Extracted:", mainWords);
  
  //   const filteredResults = this.allSfdcData.filter((item: any) => {
  //     const normalizedTitle = item.Title.toLowerCase().replace(/[^a-zA-Z0-9 ]/g, "");
  //     return mainWords.some(word => normalizedTitle.includes(word)); // Match any word
  //   });
  
  //   this.ngxService.stop();
  
  //   if (filteredResults.length > 0) {
  //     this.allSearchedData = filteredResults;
  //     this.getCorrectedKeyword();
  //     this.allResults = filteredResults.map((item: any) => {
  //       item['highlight.Title'] = item['highlight.Title']
  //         ?.replaceAll("&lt;", "<")
  //         .replaceAll("&gt;", ">")
  //         .replaceAll("&#x2F;", "/")
  //         .replaceAll("&amp;reg;", "®");
  //       return item;
  //     });
  
  //     this.allSearchResults = this.allResults.slice(0, 30);
  //     this.showMore = filteredResults.length > 30;
  //     this.showMoreData = filteredResults.slice(0, 50);
  //   } else {
  //     this.allSearchedData = null;
  //     this.allSearchResults = [];
  //   }
  
  //   this.searchService.emitData({ data: true });
  // }
  
  // public getAllSearchTask(keyword: string): void {
  //   this.ngxService.start();
  //   this.searchService.getAllSearchData(keyword)
  //     .pipe(takeUntil(this.unsubscribe$))
  //     .subscribe((resp) => {
  //       if (resp) {
  //         this.ngxService.stop();
  //         this.allSearchedData = resp;
  //         this.getCorrectedKeyword();
  //         this.allSearchResults = resp.searchRecords;
  //         this.allResults = this.allSearchResults;
  //         this.allResults = this.allResults?.map((item: any) => {
  //           item['highlight.Title'] = item['highlight.Title']?.replaceAll("&lt;", "<").replaceAll("&gt;", ">")
  //             .replaceAll("&#x2F;", "/").replaceAll("&amp;reg;", "®");
  //           return item;
  //         });
  //         this.allSearchResults = this.allResults;
  //         this.allSearchResults = resp.searchRecords?.slice(0, 30);
  //         this.showMore = this.allSearchedData?.searchRecords?.length > 30 ? true : false;
  //         this.showMoreData = resp.searchRecords?.slice(0, 50);
  //         this.searchService.emitData({ data: true });
  //       }
  //     },
  //       (err) => {
  //         this.ngxService.stop();
  //         if (err?.error?.StatusCode === "500") {
  //           this.serverError = true;
  //         }
  //       });
  // }

  /**
   * Method to show more search results
   */
  public showMoreContent(): void {
    this.allSearchResults = this.showMoreData;
    this.showMore = this.allSearchResults?.length > 30 ? false : true;
  }

  /**
   * Method to redirect to content page
   * @param title selected title
   */
  public redirectTitle(title: string): void {
    this.getCorrectedKeyword();
    const keywordSearched = this.correctedKeyword ? this.correctedKeyword : this.searchedKeyword;
    const keyword = title.replace(/[^a-zA-Z ]/g, "") + " or " + keywordSearched;
    console.log(keyword,keywordSearched,"keyword");
    type Country = 'sweden' | 'norway' | 'us';
		let country: Country  = (window as any)['country'] ? (window as any)['country'] as Country : 'us';
    const currentTimeInSeconds = Math.floor(Date.now() / 1000); //unix timestamp in seconds
    this.router.navigate([`/${config[country]?.region}/search/article-content`],
      { queryParams: { keyword: keyword, title: title, id: currentTimeInSeconds } });
  }

  /**
   * Method to get the corrected keyword
   */
  public getCorrectedKeyword(): void {
    this.correctedKeyword = "";
    this.correctedWord = this.allSearchedData?.metadata?.entityMetadata[0]?.spellCorrectionMetadata?.correctedQuery;
    if (this.allSearchedData?.metadata && this.correctedWord) {
      this.correctedKeyword = this.correctedWord ? this.correctedWord : "";
    }
  }

}
